/**
 * @file Class to check whether the user is authorized and has a resource.
 * @author Tom Verschoore de la Houssaije.
 */
import { UserService } from '../../user.service';
/**
 * Class to check whether the user is authorized and has a resource.
 */
var NeedsUserResourceGuard = /** @class */ (function () {
    /**
     * Constructs a AuthorizedRouteActivator
     * @param userService The router service for resolving dynamic routes.
     */
    function NeedsUserResourceGuard(
    /** The router service for resolving dynamic routes. */
    userService) {
        this.userService = userService;
    }
    /**
     * This method is part of the CanActivate interface that normally decides whether a Route can be activated.
     * In this case the method replaces the Route component reference strings with the resolved component constructors.
     * Angular does not support this capability by default (yet). We need this as default capability,
     * so every "route activator" we use should support this behavior.
     * @param route The route to activate.
     * @param state The state of the router.
     */
    NeedsUserResourceGuard.prototype.canActivate = function (route, state) {
        return this.userService.resourceOid !== '';
    };
    return NeedsUserResourceGuard;
}());
export { NeedsUserResourceGuard };
